module.exports = __webpack_public_path__ + "blankheadshot.png?4e509c0c70d30ab3171008342cec386d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headshots/blankheadshot.png
// module id = 9
// module chunks = 0